<ng-template [ngIf]="model.PageCount">
  <div class="results-per-page">
    <div class="input-group align-items-center">
      <div class="input-group-prepend">
        <label class="pr-2 mb-0" for="goToPage">Results per page:</label>
      </div>
      <select class="form-control bg-neutral-25" [(ngModel)]="auctionLotService.pageSize" (change)="SetPage(1)">
        <option value="30">30</option>
        <option value="60">60</option>
        <option value="90">90</option>
      </select>
    </div>
  </div>
  <div class="pagination align-items-center">
    <button *ngIf="model.CurrentPage > 1" class="btn btn-outline-secondary mr-1 pr-1 d-flex" type="button" (click)="SetPage(model.CurrentPage - 1)" aria-label="Previous"><i class="fa fa-angle-left"></i></button>
    <span>Page {{model.CurrentPage}} of {{model.PageCount}}</span>
    <button *ngIf="model.CurrentPage < model.PageCount" class="btn btn-outline-secondary ml-1 pl-1 d-flex" type="button" (click)="SetPage(model.CurrentPage + 1)" aria-label="Next"><i class="fa fa-angle-right"></i></button>
  </div>
  <div class="go-to-page">
    <div class="input-group align-items-center">
      <div class="input-group-prepend">
        <label class="mb-0 mr-2" for="goToPage">Go to page</label>
      </div>
      <input #goToPage type="number" id="goToPage" class="form-control" style="max-width: 5em;" (keyup.enter)="SetPage(goToPage.value)">
      <div class="input-group-append">
        <button class="btn btn-outline-secondary" type="button" (click)="SetPage(goToPage.value)"><i class="fa fa-angle-right"></i></button>
      </div>
    </div>
  </div>
</ng-template>
